// utils/handleApiRequest.js
import { logout } from "../redux/states/auth/slice";
import store from "../redux/store";
import { toast } from "react-hot-toast";

export async function handleApiRequest(
  method,
  request = "",
  showErrorToast = true,
  onError = () => {}
) {
  try {
    const response = await store.dispatch(method(request)).unwrap();

    // if (!response.status) {
    //   onError();
    //   if (showErrorToast) toast.error(response.error || "Something went wrong");
    //   return {};
    // }

    toast.success(response.message || "Success");
    return response;
  } catch (error) {
    console.log("api error", error);

    // Show warning toast for specific types of errors (e.g., rate limiting, warning messages)
    if (error.message) {
      toast.error(error.message || "API Error");
    }

    // Handling Unauthorized error
    if (error.statusCode === 401) {
      store.dispatch(logout());
      toast.error("Session expired. Please log in again.");
    }

    // Handle general errors
    toast.error(error.message || "API Error");

    // Optionally handle timeout or network errors
    if (error.message.includes("timeout")) {
      toast.error("Request timeout. Please try again.");
    }

    return {};
  }
}
